import { useEffect, useReducer, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { unwrapResult } from '@reduxjs/toolkit';

import { ACTIONS, initialInsuranceState, insuranceReducer } from './insuranceReducer';
import InsuranceForm from './insuranceForm';
import { errorNormalizer } from '../../../shared/Helpers/functions';

import { DispatchProperties } from '../../../redux/store';
import { getInsurance } from '../../../redux/State/clientSlice/insuranceSlice';

const UpdateInsurance = () => {
	const dispatch = useDispatch<DispatchProperties>();
	// const navigate = useNavigate();
	const { id } = useParams<{ id: string }>();

	const [insuranceInfo, setInsuranceInfo] = useReducer(insuranceReducer, initialInsuranceState);
	const [branchIds, setBranchIds] = useState<string[]>([]);
	const [saving, setSaving] = useState<boolean>(false);

	useEffect(() => {
		if (!id) return;
		dispatch(getInsurance(id))
			.then(unwrapResult)
			.then((response) => {
				// Map the response to form state
				setInsuranceInfo({ type: ACTIONS.setState, payload: response });

				// Load insurance branches (only non-virtual ones)
				// dispatch(getInsuranceBranches())
				//   .then((branches) => {
				//     const branchIds = branches
				//       .filter(b => !b.isVirtual)
				//       .map((b) => b.id);
				//     setBranchIds(branchIds);
				//   })
				//   .catch(() => {
				//     // If API fails, start with empty array
				//     setBranchIds([]);
				//   });
			})
			.catch(errorNormalizer);
	}, [id, dispatch]);

	const updateInsuranceHandler = async () => {
		if (!id || !insuranceInfo.name) return;

		setSaving(true);
		// try {
		// Create the update payload
		// const updatePayload = {
		//   ...insuranceInfo,
		//   id,
		//   branchIds,
		// };

		//   dispatch(updateInsurance(updatePayload))

		//   // Navigate back to insurance detail page
		//   navigate(`/admin/insurances`);
		// } catch (error: any) {
		//   errorNormalizer(error);
		// } finally {
		//   setSaving(false);
		// }
	};

	return (
		<InsuranceForm
			insuranceInfo={insuranceInfo}
			setInsuranceInfo={setInsuranceInfo}
			saveInsuranceHandler={updateInsuranceHandler}
			branchIds={branchIds}
			onBranchChange={setBranchIds}
			saving={saving}
		/>
	);
};

export default UpdateInsurance;
